﻿import { ajaxGet, ajaxPost, ajaxPostWithJSON } from '../../utils/ajax';

export default {
    updatePortingDetails(orderId, dealerCode, localNumber, simNumber, isEPoA, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/UpdatePortingDetails?orderId=" +
            orderId+ 
            "&dealerCode=" +
            dealerCode+
            "&localNumber=" +
            localNumber +
            "&simNumber=" +
            simNumber+
            "&isEPoA=" +
            isEPoA;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    cancelOrder(orderId, dealerCode, channelType, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/CancelOrderAsync?orderID=" +
            orderId +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    creditCardPayInitialize(orderId, returnUrl, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/InitializePayment?orderID=" +
            orderId +
            "&returnUrl=" +
            returnUrl;
        ajaxPost(url)
            .then(callback)
            .catch(errorCallback);
    }
}